export type AffiliationType =
  | 'alumni'
  | 'staff'
  | 'volunteer'
  | 'board_member'
  | 'supporter'
  | 'family'

export type MemoryAttribution = 'name' | 'initials' | 'anonymous'

export type Visibility = 'public' | 'private'

export interface RegistrationDraft {
  firstName: string
  lastName: string
  email: string
  phone: string
  affiliationType: AffiliationType | ''
  /** The primary answer: the decades they were involved, in any combination. */
  decades: string[]
  /** Optional refinement, for anyone who knows the exact years. */
  startYear: string
  endYear: string
  stillInvolved: boolean
  city: string
  programs: string[]
  roleNote: string
  memory: string
  attribution: MemoryAttribution
  visibility: Visibility
  shareMemory: boolean
  agreed: boolean
}

export const EMPTY_DRAFT: RegistrationDraft = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  affiliationType: '',
  decades: [],
  startYear: '',
  endYear: '',
  stillInvolved: false,
  city: '',
  programs: [],
  roleNote: '',
  memory: '',
  attribution: 'initials',
  visibility: 'public',
  shareMemory: false,
  agreed: false,
}

/** The wizard stores its draft as an untyped record; read it back as a draft. */
export function asDraft(data: Record<string, unknown>): RegistrationDraft {
  return { ...EMPTY_DRAFT, ...(data as Partial<RegistrationDraft>) }
}
